function getBaseUrl() {
    if (location.hostname === 'localhost') return 'http://localhost:8080'
    if (location.hostname === 'lab.reality.app') return 'https://lab.reality.app'
    if (location.hostname === 'reality.app') return 'https://reality.app'
    return location.protocol + '//' + location.hostname + ':' + location.port
}

export const baseURL = getBaseUrl()